import React from "react"
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
  useLocation,
  useResolvedPath,
} from "react-router-dom"
import { Item, ItemProps } from "./Item"

type LinkProps = ItemProps &
  RouterLinkProps & {
    exact?: boolean
  }

export const Link: React.FC<LinkProps> = ({ exact, ...props }) => {
  const path = useResolvedPath(props.to, { relative: props.relative })
  const location = useLocation()
  const endSlashPosition =
    path.pathname !== "/" && path.pathname.endsWith("/")
      ? path.pathname.length - 1
      : path.pathname.length
  const isSelected =
    location.pathname === path.pathname ||
    (!exact &&
      location.pathname.startsWith(path.pathname) &&
      location.pathname.charAt(endSlashPosition) === "/")

  return <Item as={RouterLink} isSelected={isSelected} {...props} />
}
